import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider
} from "firebase/app-check";
import {
  getAuth,
  GoogleAuthProvider,
  sendPasswordResetEmail
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDoNeQkF8In3lHVB01zgZfeY-4hRH8pf44",
  authDomain: "mnhousefinder.firebaseapp.com",
  projectId: "mnhousefinder",
  storageBucket: "mnhousefinder.firebasestorage.app",
  messagingSenderId: "794623498593",
  appId: "1:794623498593:web:c7c852f20a4e3ca1970d20",
  measurementId: "G-HJJ6Z8N9EW"
};

const app = initializeApp(firebaseConfig);

if (process.env.NODE_ENV === "production") {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      "6LfuOlEtAAAAAHyV_2Gv7y8ZEAv3xyoM-usrB3V7"
    ),
    isTokenAutoRefreshEnabled: true
  });
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);